<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
    width="500px"
  >
    <el-form
      ref="lForm"
      :model="lObject"
      size="small"
      label-width="100px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="适用组织："
            prop="deptId"
            :rules="[{ required: true, message: '请选择适用组织' }]"
          >
            <el-select
              v-model="lObject.deptId"
              placeholder="请选择适用组织"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in deptList"
                :key="i"
                :label="item.deptName"
                :value="item.uuid"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="资源类型："
            prop="resourceType"
            :rules="[{ required: true, message: '请选择资源类型' }]"
          >
            <el-select
              v-model="lObject.resourceType"
              placeholder="请选择资源类型"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in resourceTypeList"
                :key="i"
                :label="item.paramValue"
                :value="parseInt(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="时长："
            prop="duration"
            :rules="[{ required: true, message: '请输入时长' }]"
          >
            <el-input-number
              v-model="lObject.duration"
              :step="1"
               step-strictly
              :min="1"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="学时："
            prop="credit"
            :rules="[{ required: true, message: '请输入学时' }]"
          >
            <el-input-number
              v-model="lObject.credit"
              :min="0.01"
               step="0.01"
               step-strictly
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="计量单位："
            prop="unit"
            :rules="[{ required: true, message: '请选择计量单位' }]"
          >
            <el-select
              v-model="lObject.unit"
              placeholder="请选择计量单位"
              style="width:100%;"
            >
              <el-option
                v-for="(item, i) in unitTypeList"
                :key="i"
                :label="item.paramValue"
                :value="parseInt(item.paramKey)"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import { topDeptList } from "@/api/dept";
import { getSysParamByTypes } from "@/api/sysParam";
import {
  creditRuleInfo,
  creditRuleSave,
  creditRuleUpdate
} from "@/api/creditRule";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      resourceTypeList: [],
      deptList: [],
      unitTypeList: [],
      isShow: false,
      title: "",
      lObject: {
        deptId: "",
        resourceType: "",
        duration: 1,
        credit: 0.01,
        unit: ""
      }
    };
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        this.resourceTypeList = res.data["CREDIT_RESOURCE_TYPE"];
        this.unitTypeList = res.data["CREDIT_RULE_UNIT"];
      });
    },
    closeFrom() {
      this.isShow = false;
      this.$refs["lForm"].resetFields();
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.lObject = {
        deptId: "",
        resourceType: "",
        duration: 1,
        credit: 0.01,
        unit: ""
      };
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(uuid) {
      creditRuleInfo(uuid).then(res => {
        if (res && res.code === 0) {
          this.lObject = res.data;
        }
      });
    },
    submitForm() {
      this.$refs["lForm"].validate(valid => {
        if (valid) {
          if (!this.lObject.uuid) {
            // 新增
            creditRuleSave(this.lObject).then(res => {
              if (!res || res.code !== 0) return;
              Bus.$emit("reload");
              this.closeFrom();
            });
          } else {
            //编辑
            creditRuleUpdate(this.lObject).then(res => {
              if (!res || res.code !== 0) return;
              Bus.$emit("reload");
              this.closeFrom();
            });
          }
        }
      });
    }
  },
  created() {
    const _this = this;
    _this.getSysParamByTypes(["CREDIT_RESOURCE_TYPE", "CREDIT_RULE_UNIT"]);
    topDeptList().then(res => {
      if (!res || res.code !== 0) return;
      this.deptList = res.data;
    });

    Bus.$on("addCr", () => {
      this.showFrom("新增");
    });
    Bus.$on("updateCr", uuid => {
      this.info(uuid);
      this.showFrom("编辑");
    });
  },
  beforeDestroy() {
    Bus.$off("addCr");
    Bus.$off("updateCr");
  }
};
</script>
